import { FileUpload } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import { DragEvent } from "react";
import { useStyles } from "./style";

const FileDrop = ({ handleDrop, handleClick, label, accept }: any) => {
  const theme = useTheme();
  const style = useStyles();

  // Define the event handlers
  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    // setIsOver(true);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    // setIsOver(false);
  };

  return (
    <Box flex={1}>
      <input
        type="file"
        onChange={handleClick}
        accept={accept}
        multiple
        style={{ display: "none" }}
        id="file-upload"
      />
      <label htmlFor="file-upload" style={{ flex: 1 }}>
        <Box
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{ backgroundColor: theme.palette.common.white }}
          className={style.dropzone}
        >
          <FileUpload color={"disabled"} height={35} width={35} />
          <Typography
            variant="caption"
            color={theme.palette.action.disabled}
            fontWeight={"bold"}
          >
            {label}
          </Typography>
        </Box>
      </label>
    </Box>
  );
};

export default FileDrop;
